import * as types from "./types"
import http from "@/utils/http"
import router from '@/router/index'
// 轻提示
import { Toast } from 'vant';

let state = {
    nonePlate: "", // 临时车牌
    nonePlateMessage: {
      action:"",
      msg:""
    }, // 状态
    licensePlate: "", // 临时车牌
    temporaryCarList: [],
    temporaryCarDetail: {},
    temporaryChargeQueryResult: {},
    carNo: "", // 临停缴费车牌
    orderCouponList: []
}
let actions = {
    /** 临停缴费 */
    [types.TRMPORARYCHARGEPAYQUERY](context, params) { // 可缴费车辆列表
        http.post('p-ypt-temporaryChargePay-query', params).then(data => {
            context.commit(types.TRMPORARYCHARGEPAYQUERY, data)
        })
    },
    [types.TRMPORARYCHARGEADD](context, params) {    // 提交临停缴费订单
        http.post('p-ypt-temporaryCharge-add', params).then(data => {
            context.commit(types.TRMPORARYCHARGEADD, data)
        })
    },
    [types.TRMPORARYCHARGEQUERY](context, params) {    // 车辆临停缴费详情
        http.post('p-ypt-temporaryCharge-query', params).then(data => {
            context.commit(types.TRMPORARYCHARGEQUERY, data)
        })
    },
    [types.ORDERMERBERCOUPONSQUERY](context, params) {    // 订单优惠券列表
        http.post('p-ypt-orderMerberCoupons-query', params).then(data => {
            context.commit(types.ORDERMERBERCOUPONSQUERY, data)
        })
    },
    /** 无牌车请求入场 */
    [types.NONELICENSEPLATEQUERY](context, params) { // 生成临时车牌
        http.post('p-app-noneLicensePlate-query', params).then(data => {
            context.commit(types.NONELICENSEPLATEQUERY, data)
        })
    },
    [types.NONELICENSEPLATEAPPROACH](context, params) { // 无牌车入场请求
        state.nonePlateMessage.action = "await"
        http.post('p-app-noneLicensePlate-approach', params).then(data => {
            context.commit(types.NONELICENSEPLATEAPPROACH, data)
        })
    }
}
let mutations = {
    /** 临停缴费 */
    [types.TRMPORARYCHARGEPAYQUERY](state, data) {
        if (data.code==='ok') {
            state.temporaryCarList = data.data
        } else {
            Toast(data.message)
        }
    },
    [types.TRMPORARYCHARGEADD](state, data) {
        if (data.code==='ok') {
        } else {
            Toast(data.message)
        }
    },
    [types.TRMPORARYCHARGEQUERY](state, data) {
        if (data.code==='ok') {
            state.temporaryCarDetail = data.data
        } else {
            Toast(data.message)
        }
    },
    [types.ORDERMERBERCOUPONSQUERY](state, data) {
        if (data.code==='ok') {
            state.orderCouponList = data.data.dataList
        } else {
            Toast(data.message)
        }
    },
    /** 无牌车请求入场 */
    [types.NONELICENSEPLATEQUERY](state, data) {
        if (data.code==='ok') {
            state.nonePlate = data.data
        } else {
            Toast(data.message)
        }
    },
    [types.NONELICENSEPLATEAPPROACH](state, data) {
        if (data.code==='ok') {
            // Toast("入场成功")
            // router.push('/temporary/enter')
        } else {
            Toast(data.message)
        }
    },
    // 设置 临停 websocket回传数据
    setTemporaryData(state, data) {
        state.temporaryCarDetail = data
        state.carNo = data.carNo
    },
    setTemporaryChargeQueryResult(state, data) {
        state.temporaryChargeQueryResult = data
    },
    // 重置 临停 websocket数据
    resetTemporaryData(state, data) {
        state.temporaryCarDetail = {}
        state.carNo = ''
    },
    setTemporaryCarNo(state, data) {
        state.carNo = data
    },
    setNoneLicensePlateMessage(state, data) {
        state.nonePlateMessage = data
    }

}


export default { state, actions, mutations }



// WEBPACK FOOTER //
// ./src/store/temporary/index.js